import React from "react";
import "../App.css";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Moment from "moment";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";
import * as moment from "moment";
import { DownloadAttachmentServiceImages } from "../Actions/CommonAPI";
import { OverlayTrigger, Popover } from "react-bootstrap";
import i18n from "./DropdownLanguage/i18n";

class ServiceTypeCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0,
      rows: 10,
      first2: 0,
      rows2: 10,
      modalIsOpen: false,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  ShowRightPanel = (id, item) => {
    console.log(item, 'whole');

    this.props.dispatch({ type: "ShowEquipmentDetails", data: true });
    const { dispatch, match, shipId } = this.props;

    this.props.history.push(`/Home/ShipDetails/Equipment/${id}/${shipId}`);

    if (match.params.id) {
      // dispatch(getEquipmentHistory(shipId));
    }
    window.scrollTo(0, 0);
  };
  downloadDocument = (id) => {
    this.props.dispatch(DownloadAttachmentServiceImages(id));
  };
  rendereditdetails(props) {
    const { t } = this.props;
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label>{t("ClientManagementScreenContent.ViewDetails")}</label>
        </Popover.Content>
      </Popover>
    );
  }
  render() {
    const { arraylist, pageSize, totalRecords, t } = this.props;
    return (
      <div className="pb-3">
        <div
          className="card MM-card-header"
          style={{ backgroundColor: "white" }}
        >
          <div className="card-body">
            <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
              {t("EquipmentServiceTypes.EquipmentServiceTypes")}
            </h5>
          </div>
        </div>
        {this.renderCardData()}

        {/* {arraylist.length != 0 ? (
          <Paginator
            first={this.state.first}
            rows={pageSize}
            totalRecords={totalRecords}
            onPageChange={(e) => this.onPaginatorChange(e)}>
          </Paginator>
        ) : (
            <div className="card" style={{ overflow: "hidden", position: "relative" }}>
              <div class="container">
                <h6 className="resource-list-title no-item-card">
                  No Item to Display
              </h6>
              </div>
            </div>
          )} */}
      </div>
    );
  }

  // onPaginatorChange(event) {
  //   this.setState({
  //     first: event.first,
  //   });
  //   const { setUpdatedState } = this.props;
  //   setUpdatedState(event.page + 1);
  // }

  renderCardData = () => {
    const { arraylist, editEquipmentDetailsPane, t } = this.props;
    const isArabic = i18n.language === 'arab'
    return arraylist && arraylist.length ? (
      arraylist.map((item, index) => {
        return (
          <div
            className="card"
            style={{
              overflow: "hidden",
              position: "relative",
              marginBottom: "5px",
            }}
          >
            <div className="p-3">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div
                    className={
                      editEquipmentDetailsPane
                        ? "col-sm-9 col-md-9 col-9 col-m-auto"
                        : "col-sm-10 col-md-10 col-10 col-m-auto"
                    }
                  >
                    <div className="row">
                      <div className="col-sm-12 col-md-12 pb-2">
                        <h6
                          className={
                            editEquipmentDetailsPane
                              ? "resource-list-title"
                              : "resource-list-title"
                          }
                          onClick={
                            !editEquipmentDetailsPane
                              ? () => this.editEquipmentServiceType(item)
                              : () => this.ShowRightPanel(item.shipEquipmentId, item)
                          }
                        >
                          {item.serviceType ? item.serviceType : ""}
                        </h6>
                      </div>
                      <div
                        className={
                          editEquipmentDetailsPane
                            ? "col-sm-6 mb-2"
                            : "col-sm-4 "
                        }
                      >
                        <span>
                          <strong>{t("ShipEquipmentStatusScreen.EquipmentName")}: </strong>
                          <span className="italicFont">
                            {item.equipmentName ? item.equipmentName : ""}
                          </span>
                        </span>
                      </div>
                      <div
                        className={
                          editEquipmentDetailsPane
                            ? "col-sm-6 mb-2"
                            : "col-sm-4"
                        }
                      >
                        <span className={`${isArabic ? 'arabic_ship' : ''}`}>
                          <strong>{t("ShipDetailsScreen.ServiceDate")} </strong>
                          <strong>:</strong>

                        </span>
                        <span className="italicFont">
                          {item.serviceDate
                            ? moment(item.serviceDate).format("DD MMM YYYY")
                            : ""}
                        </span>
                      </div>
                      <div
                        className={
                          editEquipmentDetailsPane ? "col-sm-6" : "col-sm-4"
                        }
                      >
                        <span className={`${isArabic ? 'arabic_ship' : ''}`}>
                          <strong>{t("ShipDetailsScreen.NextDue")} </strong>
                          <strong>:</strong>
                          {/* <i aria-hidden="true"></i>{" "} */}

                        </span>
                        <span className="italicFont">
                          {item.nextDueIn
                            ? moment(item.nextDueIn).format("DD MMM YYYY")
                            : ""}
                        </span>
                      </div>
                      <div
                        className={
                          editEquipmentDetailsPane ? "col-sm-6" : "col-sm-4"
                        }>
                        <span>
                          <strong>{t("content.Servicetype")}: </strong>

                          <span className="italicFont">
                            {item.isShore ? "Shore" : item.isShip ? "Ship" : ""}
                          </span>
                        </span>
                      </div>
                      <div
                        className={
                          editEquipmentDetailsPane ? "col-sm-6" : "col-sm-4"
                        }
                      >
                        <span>
                          <strong>{t("ShipDetailsScreen.ServicePhotos")}: </strong>
                          <i aria-hidden="true"></i>{" "}
                          {item.hasServiceImages && item.isApproved ? (
                            <i
                              className="fa fa-download ml-1 fa-lg click"
                              style={{ width: 20 }}
                              onClick={() =>
                                this.downloadDocument(item.equipmentServiceId)
                              }
                            ></i>
                          ) : (
                            <></>
                          )}
                        </span>
                      </div>
                      <div
                        className={
                          editEquipmentDetailsPane ? "col-sm-6 textnowrap" : "col-sm-4 textnowrap"
                        }
                      >
                        <span className={`${isArabic ? 'arabic_ship' : ''}`}>
                          <strong>{t("ServiceUpdateContent.ServiceQty")} </strong><strong> : </strong>{""}
                          <strong>{t("ShipEquipmentStatusScreen.Total")} </strong> <strong> - </strong>{" "} <span className="italicFont">{item.totalEquipmentQty}</span>{" "}
                          <strong>{t("ServiceUpdateContent.Serviced")}  </strong> <strong> - </strong>{" "}<span className="italicFont">{item.servicedQty}</span>{" "}
                          <strong>{t("ShipManagementContent.Pending")}  </strong> <strong> - </strong>{" "} <span className="italicFont">{(item.totalEquipmentQty - item.servicedQty) < 0 ? 0 : (item.totalEquipmentQty - item.servicedQty)}</span>{" "}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div
                    className={
                      editEquipmentDetailsPane
                        ? "col-sm-1 col-md-1 col-1 col-m-auto text-right"
                        : "col-sm-2 col-md-2 col-2 col-m-auto text-right"
                    }
                  >
                    <OverlayTrigger
                      placement="bottom"
                      delay={{ show: 250, hide: 400 }}
                      overlay={this.rendereditdetails()}
                    >
                      <i
                        className="fa fa-edit click"
                        aria-hidden="true"
                        onClick={() => this.editEquipmentServiceType(item)}
                        style={{ color: " #1a3464", fontSize: "2em" }}
                      ></i>
                    </OverlayTrigger>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })
    ) : (
      <div
        className="card"
        style={{ overflow: "hidden", position: "relative" }}
      >
        <div class="container">
          <h6 className="resource-list-title no-item-card">
            {t("CommonText.NoItem")}
          </h6>
        </div>
      </div>
    );
  };

  // ShowSidePanel = (id) => {
  //   this.props.dispatch({ type: "ShowSidePan", data: true });
  //   this.props.history.push(`/Home/EquipmentEdit/${id}/single`);
  // };

  editEquipmentServiceType = (item) => {
    console.log(item);

    const { dispatch } = this.props;
    dispatch({ type: "EditEquipmentDetails", data: true });
    dispatch({ type: "EquipmentServiceTypeDetail", data: item });
    dispatch({ type: "GET_SERVICEUPDATE_EQUIPMENTTYPE", data: item?.contractType });

    // this.props.history.push(`/Home/ShipDetails/EquipmentEdit/${equipmentDetail.shipEquipmentId}/${type}`);
  };
}

function mapStateToProps(state) {
  return {
    // equipmentInfo: state.ShipEquipmentReducer.EquipmentInfo || {},
    editEquipmentDetailsPane:
      state.SidePanReducer.EditEquipmentDetails || false,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withTranslation()(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ServiceTypeCard)
));
